import React from "react";
import { motion } from "framer-motion";

function Contact() {
  const fadeInDown = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const inputStyle = {
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    background: "#f8f9fb",
    outline: "none",
    fontSize: "14px"
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <motion.div 
      initial="hidden" 
      animate="visible" 
      className="contact-wrapper px-4 sm:px-6"
      style={{ paddingTop: "60px" }} 
    >

      {/* HEADING SECTION */}
      <motion.div 
        variants={fadeInDown} 
        className="text-center mb-8 sm:mb-10"
      >
        <h2 style={{ fontSize: "38px", fontWeight: "900", color: "#0f2b46", textTransform: "uppercase", letterSpacing: "1px", margin: "0" }}>
          Contact Us
        </h2>
        <div className="flex items-center justify-center mt-2">
          <div style={{ width: "80px", height: "3px", backgroundColor: "#22c55e" }}></div>
          <div style={{ width: "100px", height: "14px", backgroundColor: "#0f2b46", margin: "0 10px" }}></div>
          <div style={{ width: "80px", height: "3px", backgroundColor: "#22c55e" }}></div>
        </div>
      </motion.div>

      <div className="contact-container">
        
        {/* MOBILE: column, DESKTOP: same */}
        <div className="contact-grid flex flex-col lg:grid lg:grid-cols-2 gap-10">

          {/* LEFT SIDE */}
          <motion.div 
            variants={staggerContainer} 
            className="pr-0 lg:pr-5"
          >
            <motion.h1 
              variants={fadeInUp} 
              className="contact-title text-center lg:text-left"
              style={{
                fontSize: "30px",
                marginBottom: "15px",
                fontWeight: "700",
                color: "#22c55e", 
                letterSpacing: "0.5px"
              }}
            >
              Get in Touch
            </motion.h1>

            <div 
              className="contact-form grid grid-cols-1 sm:grid-cols-2 gap-3"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px"
              }}
            >
              <motion.input variants={fadeInUp} type="text" placeholder="Full Name" style={inputStyle} />
              <motion.input variants={fadeInUp} type="email" placeholder="Email" style={inputStyle} />
              <motion.input variants={fadeInUp} type="text" placeholder="Phone" style={inputStyle} />
              <motion.input variants={fadeInUp} type="text" placeholder="Company" style={inputStyle} />

              <motion.input 
                variants={fadeInUp} 
                type="text" 
                placeholder="Country" 
                style={{ ...inputStyle, gridColumn: "span 2" }} 
                className="col-span-1 sm:col-span-2"
              />
              
              <motion.select 
                variants={fadeInUp} 
                style={{ ...inputStyle, gridColumn: "span 2" }}
                className="col-span-1 sm:col-span-2"
              >
                <option>Select Inquiry Type</option>
                <option>Company Registration</option>
                <option>GST Compliance</option>
                <option>Trademark Support</option>
              </motion.select>

              <motion.textarea 
                variants={fadeInUp} 
                placeholder="Your Message"
                style={{
                  gridColumn: "span 2",
                  height: "110px",
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                  background: "#f8f9fb",
                  outline: "none"
                }}
                className="col-span-1 sm:col-span-2"
              />
            </div>

            <motion.div 
              variants={fadeInUp} 
              className="mt-3 flex items-start"
              style={{ marginTop: "10px" }}
            >
              <input type="checkbox" id="privacy" />
              <label htmlFor="privacy" className="ml-2 text-sm">
                I agree to the Privacy Policy & Terms
              </label>
            </motion.div>

            <motion.button 
              variants={fadeInUp}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full sm:w-auto"
              style={{
                marginTop: "15px",
                padding: "10px 22px",
                background: "#2563eb",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "14px"
              }}
            >
              Send Message
            </motion.button>
          </motion.div>

          {/* RIGHT SIDE */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }} 
            animate={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-center lg:text-left"
          >
            <h1 className="contact-title" style={{ fontSize: "30px", marginBottom: "15px", color: "#22c55e" }}>
              Our Office
            </h1>

            <div className="office-card p-4 sm:p-5" style={{ padding: "20px" }}>
              <h3 style={{ marginTop: "0" }}>Manoj V. Ayadi & Associates</h3>
              <p>Office No. F-79, First Floor, Haware Fantasia Business Park,</p>
              <p>Near Inorbit Mall, Sector 30A, Vashi,</p>
              <p>Navi Mumbai, Maharashtra - 400703</p>
              <p>Email: office@csmanojayadi.com</p>
              <p>Office: 022-65027026</p>
              <p>Mobile: +91 9773112128</p>
            </div>

            <motion.div 
              initial={{ opacity: 0, x: 50 }} 
              whileInView={{ opacity: 1, x: 0 }} 
              viewport={{ once: true }} 
              transition={{ duration: 0.8, delay: 0.2 }}
              className="mt-5"
            >                           
              <div className="overflow-hidden rounded-lg">
                <iframe 
                  title="Office Location Map" 
                  src="https://www.google.com/maps?output=embed&q=Manoj+V+Ayadi+Associates+Haware+Fantasia+Vashi+Navi+Mumbai" 
                  width="100%" 
                  height="300" 
                  className="sm:h-[350px]"
                  style={{ border: 0 }} 
                  loading="lazy">
                </iframe>
              </div>
            </motion.div>

          </motion.div>

        </div>
      </div>
    </motion.div>
  );
}

export default Contact;